import { faCheckDouble } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loading from "components/loading";
import { EventProvider, useEvent } from "contexts/event";
import { JudgingProvider, useJudging } from "contexts/judging";
import React, { useState } from "react";
import { useLoaderData } from "react-router-dom";
import 'style/mobileView.scss';
import './judging.scss';
import moment from "moment";

export async function loader({params}) {
    return params;
}

function Judging() {
    const loaderData = useLoaderData();

    return (
        <div className='mobile-view within-portal'>
            <EventProvider eventId={loaderData.eventId} >
                <JudgingProvider eventId={loaderData.eventId}>
                    <JudgingHome />
                </JudgingProvider>
            </EventProvider>
        </div>
    )
}

function JudgingHome() {
    const { eventLoading, event } = useEvent();
    const { formsLoading, forms, isVerified, judgesForm } = useJudging();
    const [form, setForm] = useState(null);
    const [judgeId, setJudgeId] = useState('');

    const formSelectHandler = (form) => {
        setForm(form);
    }

    const onBackHandler = () => {
        setForm(null);
    }

    return (
        <div className='view-container home'>
            {eventLoading ? <Loading /> :
                <>
                    <h1>{event.name}</h1>
                    <h2>Judging Form</h2>
                    {moment().isAfter(event.endDate) ? (
                        <p>This event has ended and judging is no longer allowed.</p>
                    ) : event.voting == 2 ?
                        <>
                            {!isVerified ? <JudgeVerification judgeId={judgeId} setJudgeId={setJudgeId} /> :
                                <div>
                                    <p>Your have been verified.</p>
                                    {form ? <Form judgeId={judgeId} form={form} onBack={onBackHandler} /> :
                                        <>
                                            <p>Select the judging form you would like to use:</p>
                                            <ul className='formList'>
                                                {formsLoading ? <Loading /> :
                                                    forms
                                                        .filter(form => judgesForm == 0 || form.id == judgesForm)
                                                        .map((form, idx) => 
                                                        <li key={idx} onClick={() => formSelectHandler(form)}>
                                                            <FontAwesomeIcon icon={faCheckDouble}/>{form.title}</li>
                                                        )
                                                }
                                            </ul>
                                        </>
                                    }
                                </div>
                            }
                        </>
                        : <p>This event does not use judging</p>
                    }
                </>
            }
        </div>
    )
}

function JudgeVerification({ judgeId, setJudgeId }) {
    const { verifyJudge, codeSent, message } = useJudging();
    const [code, setCode] = useState('');

    const getVerificationCodeHandler = () => {
        verifyJudge({judgeId});
    }

    const submitVerificationCodeHandler = () => {
        verifyJudge({judgeId, code, verify: true});
    }

    return (
        <div>
            <p>Provide your judging id to begin the verification process</p>
            <input type='text' value={judgeId} onChange={evt => setJudgeId(evt.target.value)} maxLength={4} />
            <button onClick={getVerificationCodeHandler} disabled={judgeId.length == 0}>
                {codeSent ? 'Resend verificaiton code' : 'Send verification code'}</button>
            {codeSent && 
                <>
                    <p>Enter the verification code that was just sent as a text message to you.</p>
                    <input type='text' value={code} onChange={evt => setCode(evt.target.value)} maxLength={7} />
                    <button onClick={submitVerificationCodeHandler}>Submit Verification code</button>
                </>
            }
            <div>{message}</div>
        </div>
    )
}

function Form({ judgeId, form, onBack }) {
    const [carNumber, setCarNumber] = useState('');
    const { submitJudgingForm } = useJudging();
    // Store initial scores as an array of objects
    const initialScores = React.useMemo(
        () => form.criteria.map(crit => ({
            criteriaId: crit.id,
            score: crit.maxScore
        })),
        [form.criteria]
    );
    const [scores, setScores] = useState(initialScores);

    const handleCarNumberChange = evt => {
        // Only allow up to 4 digits
        const value = evt.target.value.replace(/\D/g, '').slice(0, 4);
        setCarNumber(value);
    };

    const handleScoreChange = (criteriaId, value) => {
        setScores(prev =>
            prev.map(s =>
                s.criteriaId === criteriaId ? { ...s, score: value } : s
            )
        );
    };

    const onSubmitForm = () => {
        const data = {
            judgeId,
            entryId: carNumber,
            scores,
        }
        submitJudgingForm(data, (response) => {
            if (response.accepted) {
                alert(`Your scores for ${carNumber} have been accepted.`);
                resetForm();
            } else {
                alert(`Your scores for ${carNumber} were not accepted. Reason: ${response.reason}`);
            }
        })
    }

    const resetForm = () => {
        setCarNumber('');
        setScores(initialScores);
    }

    return (
        <div className='judgingForm'>
            <h2>{form.title}</h2>
            <label>Car Number</label>
            <input
                type='text' 
                value={carNumber} 
                onChange={handleCarNumberChange}
                maxLength={4}
                inputMode="numeric"
                pattern="\d*"
             />
            {form.criteria.map(crit => (
                <Criteria 
                    key={crit.id} 
                    criteria={crit}
                    score={scores.find(s => s.criteriaId === crit.id)?.score}
                    onScoreChange={handleScoreChange} />
            ))}
            <div>
                <button onClick={onBack}>Go back to forms</button>
                <button onClick={onSubmitForm}>Submit Scores</button>
            </div>
        </div>
    )
}

function Criteria({ criteria, score, onScoreChange }) {

    return (
        <div>
            <h3>{criteria.title}</h3>
            <div>{`Scoring: min: ${criteria.minScore} - max: ${criteria.maxScore} (Weight: ${criteria.weight})`}</div>
            <label>Your Score</label>
            <input type='text'
                value={score}
                onChange={evt => onScoreChange(criteria.id, evt.target.value)}
                min={criteria.minScore} 
                max={criteria.maxScore} 
                inputMode="numeric"
                pattern="\d*"/>
            <hr />
        </div>
    )
}

export default Judging;